import PropTypes from 'prop-types';
import React from 'react';
import { Button, ProgressBar } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';

// component dedicated to result progression bar and final results fetching when they are ready

class SpecialProgressBarSuggest extends React.PureComponent {

  state = {
    intervalId:null
  }

  componentDidMount() {
    const intervalId = setInterval(() => {
      this.fetchResult();
    }, 1000);
    this.setState({intervalId:intervalId})
  }

  componentWillUnmount(){
    console.log("clearInterval");
    clearInterval(this.state.intervalId);
  }


  stopQuery= ()=> {
      this.fetchResult(true);
      clearInterval(this.state.intervalId);
      this.props.stopWaitingSuggestion();
  };

  fetchResult= (completed)=> {
    const endpoint = '/sessions/'+this.props.session_id+"/"+this.props.tmpName;
		fetch(
		  process.env.REACT_APP_API_BASE + endpoint, {
      credentials: "omit",
      headers: { 'Content-Type': 'application/json' },
      method: 'GET',
		})
		.then((res) => {
			if (res.status === 200) {
				res.json().then((data) => {
          if (completed) {
            data['completed']=1;
          }
					this.props.setExamples( data );
				})
			}
		})
		.catch(() => {
			console.log(`Network error when trying to fetch ${endpoint}`);
		})
	}


  render() {

    return  <>
              { ! this.state.interruption && 
                <center>
                  <ProgressBar/>
                  <br/>
                  <Button icon="stop" onClick={this.stopQuery}>Stop</Button>
                </center>
              }
            </>
  }
}

SpecialProgressBarSuggest.propTypes = {
    session_id: PropTypes.string,
    tmpName: PropTypes.string,
    setExamples: PropTypes.func,
    stopWaitingSuggestion: PropTypes.func,
};
      
export default withTranslation()(SpecialProgressBarSuggest);
      